import { formatDistance } from './en-US/_lib/formatDistance.js';
import { formatLong } from './en-US/_lib/formatLong.js';
import { formatRelative } from './en-US/_lib/formatRelative.js';
import { localize } from './en-US/_lib/localize.js';
import { match } from './en-US/_lib/match.js';

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

export { enUS };
